// extracted by mini-css-extract-plugin
module.exports = {"action-btn":"StudioAppBarAdminMenu_action-btn__IuwxH","popover":"StudioAppBarAdminMenu_popover__sm_mO","btn":"StudioAppBarAdminMenu_btn__Vpd51"};